import request from '@/assets/js/request';
import qs from 'qs';

/**
 * 获取专辑下的歌曲列表
 * @param {String} albumId 专辑ID
 * @returns
 */
export function fetchAlbumSongList(albumId) {
    return request({
        url: '/newAlbumTrack/view/list',
        method: 'GET',
        params: {albumId},
    });
}

/**
 * AI解析音频数据
 * @param {String} audioPath 音频地址
 * @param {String} type 轮询类型
 */
export function aiAudioParse(audioPath, type) {
    return request({
        url: '/ai/audioParse',
        method: 'POST',
        data: {audioPath, type},
        formData: false,
    });
}

/**
 * AI解析音频停止
 * @param {String} taskId 任务id
 * @param {String} type 1.歌词识别，2.曲风识别
 */
export function aiAudioStop(taskId, type) {
    return request({
        url: '/ai/stopAudioParse',
        method: 'POST',
        data: {taskId, type},
        formData: false,
    });
}
/**
 * 节假日
 * @param date
 */

export function getHolidayData(date) {
    return request({
        url: '/common/holiday',
        method: 'get',
        params: {date},
    });
}
/**
 * @description 艺人关联主页查询
 * @param {*} ids
 */
export function fetchListRelateArtist(data) {
    const ids = data.join(',');
    return request({
        url: `/artist/listRelateArtist`,
        method: 'get',
        params: {ids},
    });
}

/**
 * @description 解除AppleMusic关联
 * @param {*} appleId：appleId
 * @param {*} artistId：艺人id
 * @param {*} appleIdSource：来源,1:页面查询,2:手动输入
 */
export function unrelateAppleMusic({appleId, artistId, appleIdSource}) {
    return request({
        url: '/artist/apple-artist/unrelate',
        method: 'post',
        data: {appleId, artistId, appleIdSource},
    });
}

/**
 * @description 解除spotify关联
 * @param {*} spotifyId：spotifyId
 * @param {*} artistId：艺人id
 */
export function unrelateSpotify({spotifyId, artistId}) {
    return request({
        url: '/artist/unrelateSpotify',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        data: {spotifyId, artistId},
        formData: false,
    });
}

/**
 * @description 搜索spotify艺人
 * @param {*} data
 */
export function searchSpotify(data) {
    return request({
        url: '/artist/searchSpotify',
        method: 'get',
        params: data,
    });
}

/**
 * @description 查询AppleMusic艺人
 * @param {*} name
 */
export function searchSpotifyById(id) {
    return request({
        url: '/artist/searchSpotifyById',
        method: 'get',
        params: id,
    });
}

/**
 * @description 查询AppleMusic艺人
 * @param {*} name
 */
export function fetchAppleMusic({name}) {
    return request({
        url: '/artist/apple-artist/lookup',
        method: 'get',
        params: {name},
    });
}

/**
 * @description 查询AppleMusic艺人
 * @param {*} name
 */
export function fetchAppleMusicArtist(id) {
    return request({
        url: '/artist/apple-artist/lookupById',
        method: 'get',
        params: id,
    });
}

/**
 * @description 关联AppleMusic艺人
 * @param {*} appleId
 * @param {*} artistId
 */
export function relAppleMusicArtist({appleId, artistId, appleIdSource}) {
    return request({
        url: '/artist/apple-artist/relate',
        method: 'post',
        data: {appleId, artistId, appleIdSource},
    });
}

/*
 * @description 关联spotify的艺人
 * @param {*} spotifyId
 * @param {*} artistId
 * @param {*} spotifyName
 */
export function relateSpotify({spotifyId, artistId, spotifyName, coverUrl}) {
    return request({
        url: '/artist/relateSpotify',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        data: {spotifyId, artistId, spotifyName, coverUrl},
        formData: false,
    });
}
/**
 * @description markCreateSpotify
 * @param {*} ids
 */
export function markCreateSpotify({ids}) {
    return request({
        url: '/artist/markCreateSpotify',
        method: 'post',
        data: {ids},
    });
}

/**
 * @description 查看歌曲被专辑引用的锁
 * @param {*} taskId
 */
export function checkTrackIfLock({trackId, albumId}) {
    return request({
        url: 'track/ifLock',
        method: 'get',
        params: {trackId, albumId},
    });
}

/**
 * @description 获取平台绑定详情
 * @param {String|Number} artistId 艺人ID
 * @param {Number} platformType 平台类型: 1=网易云 2=QQ音乐
 */
export function getPlatformArtistBindingDetail(artistId, platformType) {
    return request({
        url: '/artist/platform-artist/binding-detail',
        method: 'get',
        params: {artistId, platformType}
    });
}

/**
 * @description 统一关联平台艺人(Apple/Spotify/网易云/QQ)
 * @param {Object} data 请求体JSON参数
 */
export function relatePlatformArtist(data) {
    return request({
        url: '/artist/platform-artist/relate',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data,
        formData: false
    });
}

/**
 * @description 同步平台艺人信息
 * @param {*} artistId
 * @param {*} platformType
 */
export function syncPlatformArtist({artistId, platformType}) {
    return request({
        url: '/artist/platform-artist/sync',
        method: 'post',
        params: {artistId, platformType}
    });
}

/**
 * @description 统一解除平台关联
 * @param {*} artistId
 * @param {*} platformType
 */
export function unrelatePlatformArtist({artistId, platformType}) {
    return request({
        url: '/artist/platform-artist/unrelate',
        method: 'post',
        params: {artistId, platformType}
    });
}

/**
 * @description 搜索平台艺人
 * @param {*} keyword
 * @param {*} platformType
 * @param {*} pageNo
 * @param {*} pageSize
 */
export function searchPlatformArtist({keyword, platformArtistId, platformType, pageNo = 1, pageSize = 10, cursor}) {
    return request({
        url: '/artist/platform-artist/search',
        method: 'get',
        params: {keyword, platformArtistId, platformType, pageNo, pageSize, cursor}
    });
}

/**
 * @description 标记平台艺人为新建（仅支持网易云、QQ音乐、Spotify）
 * @param {Object} params
 * @param {Array} params.ids 艺人ID数组（integer数组）
 * @param {Number} params.platformType 平台类型
 */
export function markCreatePlatformArtist({ids, platformType}) {
    return request({
        url: '/artist/platform-artist/mark-create',
        method: 'post',
        data: qs.stringify({ids, platformType}),
        formData: false
    });
}

/**
 * @description 创建AppleMusic并关联艺人
 * @param {*} artistId 艺人ID
 * @param {*} locale 专辑/曲目语言编码（取自专辑接口 displayLangCode 或曲目 langCode）
 * @param {*} name 艺人名称
 */
export function createRelAppleMusicArtist({artistId, locale, name}) {
    return request({
        url: '/artist/apple-artist/create-relate',
        method: 'post',
        data: {artistId, localeCode: locale, name}
    });
}
